import { render, staticRenderFns } from "./RemoteConfig.vue?vue&type=template&id=6021cb53&scoped=true"
import script from "./RemoteConfig.vue?vue&type=script&lang=ts"
export * from "./RemoteConfig.vue?vue&type=script&lang=ts"
import style0 from "./RemoteConfig.vue?vue&type=style&index=0&id=6021cb53&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021cb53",
  null
  
)

export default component.exports